import React, { createContext, useContext, useEffect, useState } from 'react';
import { staysApi } from '../services/staysApi';

const StayCitiesContext = createContext({
  cities: [],
  loading: true
});

export function StayCitiesProvider({ children }) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    staysApi
      .getStayCities()
      .then((list) => {
        if (!cancelled) setCities(Array.isArray(list) ? list : []);
      })
      .catch((err) => {
        console.warn('Could not load stay cities:', err);
        if (!cancelled) setCities([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <StayCitiesContext.Provider value={{ cities, loading }}>
      {children}
    </StayCitiesContext.Provider>
  );
}

export function useStayCities() {
  return useContext(StayCitiesContext);
}
